import React, { ReactNode } from 'react'

import { SxProps } from '@mui/material'

import Box from 'components_new/atoms/Box'

import SectionHeader from 'components_new/molecules/SectionHeader'

export type TImportance = 'optional' | 'recommended' | 'required'

export interface NewSettingsItemProps {
  actions?: ReactNode
  children?: ReactNode
  helperText?: ReactNode
  /** Set to link to the row from elsewhere on the page. */
  id?: string
  sx?: SxProps
  title: string
  titleAdornment?: ReactNode
}

const NewSettingsItem = React.forwardRef(
  (props: NewSettingsItemProps, ref: any) => {
    const { actions, children, helperText, id, sx, title, titleAdornment } =
      props

    return (
      <Box
        id={id}
        ref={ref}
        sx={{
          py: 2,
          '&:not(:last-child)': {
            borderBottom: '1px solid',
            borderColor: 'divider'
          },
          ...sx
        }}
      >
        <Box
          sx={{
            display: 'flex',
            gap: 4,
            justifyContent: 'space-between',
            mb: children ? 2 : undefined
          }}
        >
          <SectionHeader
            helperText={helperText}
            size={'medium'}
            sx={{ flex: 1 }}
            title={title}
            titleAdornment={titleAdornment}
          />
          <Box
            sx={{
              alignItems: 'center',
              display: 'flex',
              flex: 1,
              justifyContent: 'flex-end'
            }}
          >
            {actions}
          </Box>
        </Box>
        {children}
      </Box>
    )
  }
)

NewSettingsItem.displayName = 'NewSettingsItem'
export default NewSettingsItem
